import { render, staticRenderFns } from "./employees.vue?vue&type=template&id=31bd5be0&scoped=true&"
import script from "./employees.vue?vue&type=script&lang=js&"
export * from "./employees.vue?vue&type=script&lang=js&"
import style0 from "./employees.vue?vue&type=style&index=0&id=31bd5be0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bd5be0",
  null
  
)

export default component.exports